<template>
	<v-app>
		<v-main class="login">
			<v-container class="fill-height" fluid>
				<v-row align="center" justify="center">
					<v-col cols="12" sm="8" md="4">
						<v-card class="px-5 rounded-lg elevation-0">
							<v-card-text class="pa-sm-5">
								<div class="pb-3 text-center">
									<div class="py-5 d-flex justify-center">
										<div class="login-icon"></div>
									</div>
									<div class="font-size-16 cl-primary">Masuk ke Akun Anda</div>
								</div>
								<v-form ref="formLogin" role="form" v-on:submit.prevent="onLogin">
									<v-alert dense dark v-if="Object.keys(responseError).length > 1" color="red lighten-1" dismissible> {{responseError.message}} </v-alert>
									<v-text-field placeholder="Username" ref="username" prepend-icon="mdi-account" type="text" v-model="username" tabindex="1" :rules="usernameRules"></v-text-field>
									<v-text-field placeholder="Nomor Telepon" ref="phonenumber" prepend-icon="mdi-cellphone-lock" type="text" v-model="phonenumber" tabindex="2" :rules="phonenumberRules"></v-text-field>
									<v-text-field placeholder="Password" ref="password" id="password" prepend-icon="mdi-lock" type="password" v-model="password" tabindex="3" :append-icon="iconPass" @click:append="showPassword" :rules="passwordRules"></v-text-field>
									<div id="captcha-div"></div>
									<v-text-field placeholder="Kode Unik" ref="kodeunik" id="uniqueKey" prepend-icon="mdi-qrcode" type="text" v-model="kodeunik" tabindex="4" append-icon="mdi-reload" @click:append="createCaptcha" :rules="kodeunikRules" validate-on-blur></v-text-field>
									<v-layout column align-center class="pt-5 pb-3">
										<v-flex>
											<v-btn large depressed color="primary" class="rounded-lg" :loading="btnLoadingProses" tabindex="5" :disabled="btnLoadingProses" type="submit">
												<v-icon>mdi-login-variant</v-icon>
												<span class="pl-2">Masuk</span>
											</v-btn>
										</v-flex>
									</v-layout>
								</v-form>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</v-main>
		<v-footer padless class="bg-light-primary">
			<v-col class="text-center cl-primary" cols="12">
				{{ new Date().getFullYear() }} - <strong>MLM Esoftdream</strong>
			</v-col>
		</v-footer>
	</v-app>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';


const { mapState, mapMutations, mapActions } = createNamespacedHelpers('auth');

export default {
	components: {
		
	},
	data() {
		return {
			code: null,
			btnLoadingProses: false,
			username: 'admin',
			password: 'admin123',
			phonenumber: '085393290256',
			kodeunik: '',
			iconPass: 'mdi-eye',
			usernameRules: [
			v => !!v || 'Username tidak boleh kosong',
			],
			phonenumberRules: [
			v => !!v || 'Nomor Telepon tidak boleh kosong',
			],
			passwordRules: [
			v => !!v || 'Password tidak boleh kosong',
			],
			kodeunikRules: [
			v => !!v || 'Kode Unik tidak boleh kosong',
			v => v === this.code || 'Kode Unik Salah. Coba kembali'
			],
		}
	},
	props: {
	},
	computed: {
		...mapState(['isAttempting', 'responseError']),
	},
	methods: {
		...mapMutations(['removeAlert', 'reset']),
		...mapActions(['login']),

		async onLogin() {
			if (this.$refs.formLogin.validate()) {
				this.btnLoadingProses = await true
				await this.login({ username: this.username, phonenumber: this.phonenumber, password: this.password }).then(() => {
					const { redirect } = this.$route.query;

					setTimeout(() => {
						if (redirect) {
							this.$router.push(redirect);
						} else {
							this.$router.push({ name: "dashboard" })
						}
					}, 1000);
				}).catch(() => {
					this.btnLoadingProses = false
				})
				this.btnLoadingProses = await false
			} else {
				if (!this.kodeunik) {
					setTimeout(() => {
						this.$refs.kodeunik.focus()
					}, 200);
				}

				if (!this.password) {
					setTimeout(() => {
						this.$refs.password.focus()
					}, 200);
				}

				if (!this.phonenumber) {
					setTimeout(() => {
						this.$refs.phonenumber.focus()
					}, 200);
				}

				if (!this.username) {
					setTimeout(() => {
						this.$refs.username.focus()
					}, 200);
				}
			}
		},
		showPassword() {
			var x = document.getElementById("password");
			if (x.type === "password") {
				x.type = "text"
				this.sPassword = true
				this.iconPass = 'mdi-eye-off'
			} else {
				x.type = "password"
				this.sPassword = false
				this.iconPass = 'mdi-eye'
			}
		},
		async createCaptcha() {
			const canvas = await document.getElementById('captcha-div')
			if (canvas.children.length > 0) canvas.innerHTML= await ''
				this.kodeunik = await ''

			// const charsArray = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
			const charsArray = 'ABCDEFGHKLMNPRSTUVWYZ23456789'
			const lengthOtp = 6
			let captcha = []

			for (let i = 0; i < lengthOtp; i++) {
				/*below code will not allow Repetition of Characters*/
				/*get the next character from the array*/
				let index = Math.floor(Math.random() * charsArray.length + 1)
				if (captcha.indexOf(charsArray[index]) == -1)
					captcha.push(charsArray[index])
				else i--
			}

			const canv = document.createElement('canvas')
			canv.id = 'captcha'
			canv.width = 180
			canv.height = 45
			/*canv.dir = 'ltr'*/

			let ctx = canv.getContext('2d')
			ctx.textBaseline = 'middle';
			ctx.textAlign = 'center'
			ctx.font = 'normal bold 32px serif'
			ctx.fillText(captcha.join(''), 90, 25)

			/*storing captcha so that can validate you can save it somewhere else according to your specific requirements*/
			this.code = captcha.join('')
			document.getElementById("captcha-div").appendChild(canv);
			this.kodeunik = captcha.join('')
		}
	},
	async created() {
		await this.$store.dispatch('setPageTitle', `Login Virtual Office`)
		this.createCaptcha()
	}
};
</script>